export const photos = [
  {
    src: 'gallery/1.jpg',
    width: 1080, 
    height: 720
  },
  {
    src: 'gallery/2.jpg',
    width: 1080, 
    height: 720
  }, {
    src: 'gallery/3.jpg',
    width: 1080,
    height: 720
  }, {
    src: 'gallery/4.jpg',
    width: 1080,
    height: 720
  }, {
    src: 'gallery/5.jpg',
    width: 1080,
    height: 720
  }, {
    src: 'gallery/6.jpg',
    width: 1080,
    height: 720
  }, {
    src: 'gallery/7.jpg',
    width: 1080,
    height: 720
  }, {
    src: 'gallery/8.jpg',
    width: 1080,
    height: 720
  }, {
    src: 'gallery/9.jpg',
    width: 1080,
    height: 720
  }, {
    src: 'gallery/10.jpg',
    width: 821,
    height: 1086,
  }, {
    src: 'gallery/11.jpg',
    width: 1080,
    height: 720
  }, {
    src: 'gallery/12.jpg',
    width: 1080,
    height: 720
  }, {
    src: 'gallery/13.jpg',
    width: 1080,
    height: 720
  }, {
    src: 'gallery/14.jpg',
    width: 1080,
    height: 720
  }, {
    src: 'gallery/15.jpg',
    width: 1080,
    height: 720
  }, {
    src: 'gallery/16.jpg',
    width: 1080,
    height: 720
  }, {
    src: 'gallery/17.jpg',
    width: 1080,
    height: 720
  }, {
    src: 'gallery/18.jpg',
    width: 1080,
    height: 720
  }, {
    src: 'gallery/19.jpg',
    width: 724,
    height: 1086,
  }, {
    src: 'gallery/23.jpg',
    width: 1080,
    height: 720
  }, {
    src: 'gallery/20.jpg',
    width: 452,
    height: 679
  }, {
    src: 'gallery/21.jpg',
    width: 1080,
    height: 720
  }, {
    src: 'gallery/22.jpg',
    width: 1080,
    height: 720
  }, {
    src: 'gallery/27.jpg',
    width: 1080,
    height: 720
  }, {
    src: 'gallery/25.jpg',
    width: 1080,
    height: 720
  }, {
    src: 'gallery/26.jpg',
    width: 1080,
    height: 720
  }, {
    src: 'gallery/24.jpg',
    width: 1080,
    height: 720
  }, {
    src: 'gallery/28.jpg',
    width: 1080,
    height: 720
  }, {
    src: 'gallery/29.jpg',
    width: 1080,
    height: 720
  }, {
    src: 'gallery/30.jpg',
    width: 1080,
    height: 720
  }, {
    src: 'gallery/31.jpg',
    width: 1080,
    height: 720
  }, {
    src: 'gallery/32.jpg',
    width: 1080,
    height: 720
  }, {
    src: 'gallery/33.jpg',
    width: 1080,
    height: 720
  }, {
    src: 'gallery/34.jpg',
    width: 1080,
    height: 720
  }, {
    src: 'gallery/35.jpg',
    width: 1080,
    height: 720
  }, {
    src: 'gallery/36.jpg',
    width: 1080,
    height: 720
  }, {
    src: 'gallery/37.jpg',
    width: 1080,
    height: 720
  }, {
    src: 'gallery/38.jpg',
    width: 1080,
    height: 720,
  }, {
    src: 'gallery/40.jpg',
    width: 1048,
    height: 786,
  }, {
    src: 'gallery/41.jpg',
    width: 905,
    height: 679,
  }, {
    src: 'gallery/39.jpg',
    width: 1025,
    height: 500,
  }, {
    src: 'gallery/42.jpg',
    width: 905,
    height: 1320,
  }, {
    src: 'gallery/46.jpg',
    width: 1048,
    height: 1120,
  }, {
    src: 'gallery/43.jpg',
    width: 1048,
    height: 786,
  }, {
    src: 'gallery/44.jpg',
    width: 1048,
    height: 786,
  }, {
    src: 'gallery/45.jpg',
    width: 1048,
    height: 786,
  }, 
  
];
